import { AlertDialog, useDialog as useDaxDialog } from '@global-dax-ad-platform/dax-components';
import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';

import { useFilters } from 'context/FilterProvider/FilterProvider';
import { usePaginatedItemsContext } from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import { useSelectedEntitiesContext } from 'context/SelectedEntities/SelectedEntitiesProvider';
import useStyles from 'features/Drafts/components/SyncButton/SyncButton.styles';
import useFetchData from 'hooks/useFetchData';
import { DRAFTS_PAGE_SYNC_DIALOG_ID, DRAFTS_SYNC_API_URL } from 'utils/defaults';
import { emptyFilters, toFiltersSearchParams } from 'utils/searchParamsConverter';

const SyncButton = () => {
  const classes = useStyles();

  const { selectedEntityIds, areEntitiesSelected, resetSelectedEntities } =
    useSelectedEntitiesContext();
  const { totalElements } = usePaginatedItemsContext();
  const { postData } = useFetchData();
  const { triggerRefresh } = useRefresh();
  const { openDialog: openDaxDialog } = useDaxDialog();
  const { filters } = useFilters();
  const selectedIds = selectedEntityIds();

  const syncParams = areEntitiesSelected
    ? toFiltersSearchParams({ ...emptyFilters, spaceIds: selectedIds })
    : toFiltersSearchParams(filters);

  const handleSync = async () => {
    await postData(`${DRAFTS_SYNC_API_URL}?${syncParams}`, {});
    resetSelectedEntities();
    triggerRefresh();
  };

  const entityAmount = areEntitiesSelected ? selectedIds.length : totalElements;
  const buttonLabel = areEntitiesSelected ? 'Sync Selected' : 'Sync All';
  const titlePrefix = !areEntitiesSelected && entityAmount > 1 ? 'All ' : '';

  if (!areEntitiesSelected && !totalElements) return null;

  return (
    <>
      <AlertDialog
        dialogId={DRAFTS_PAGE_SYNC_DIALOG_ID}
        content={{
          title: `Sync ${titlePrefix}Draft${entityAmount > 1 ? 's' : ''}`,
          main: (
            <Typography color="textPrimary" variant="body2">
              Click continue to <strong>Sync</strong> {entityAmount} Draft
              {entityAmount > 1 && 's'}
            </Typography>
          ),
        }}
        action={{
          label: 'Continue',
          onClick: handleSync,
        }}
      />
      <Button
        onClick={() => openDaxDialog(DRAFTS_PAGE_SYNC_DIALOG_ID)}
        variant="outlined"
        className={classes.root}
      >
        {buttonLabel}
      </Button>
    </>
  );
};

export default SyncButton;
